import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const NewsLetter = props => {
  return (
    <SvgIcon {...props} width="26.331" height="26.331" viewBox="0 0 26.331 26.331">
      <g transform="translate(-1 -1)">
        <path d="M5.389,7.583H1V24.588a2.746,2.746,0,0,0,2.743,2.743H24.588a2.746,2.746,0,0,0,2.743-2.743V1H5.389ZM2.1,24.588V8.68H5.389V24.588a1.646,1.646,0,0,1-3.291,0ZM6.486,2.1H26.234V24.588a1.648,1.648,0,0,1-1.646,1.646H5.936c.016-.021.028-.046.043-.068.031-.044.059-.091.087-.138a2.681,2.681,0,0,0,.157-.29c.025-.053.048-.106.069-.16a2.742,2.742,0,0,0,.1-.328c.013-.052.029-.1.038-.154a2.678,2.678,0,0,0,.052-.509V2.1Z" />
        <rect width="15" height="1" transform="translate(9 5.331)" />
        <rect width="11" height="1" transform="translate(11 7.331)" />
        <rect width="7" height="1" transform="translate(17 12.331)" />
        <rect width="7" height="1" transform="translate(17 14.331)" />
        <path d="M21.583,21H15v6.583h6.583Zm-1.1,5.486H16.1V22.1h4.389Z" transform="translate(-6.32 -9.029)" />
        <rect width="7" height="1" transform="translate(17 17.331)" />
        <rect width="6" height="1" transform="translate(9 20.331)" />
        <rect width="7" height="1" transform="translate(17 20.331)" />
        <rect width="6" height="1" transform="translate(9 23.331)" />
        <rect width="7" height="1" transform="translate(17 23.331)" />
      </g>
    </SvgIcon>
  );
};

export default NewsLetter;
